import { gsap, Power1, Power2 } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { MenuToggle } from './elements/menu-toggle'
import { breakpointUp } from './utils/breakpoints'
import { smoothScrollCreate, smoothScrollKill } from './scroll-smoother'

gsap.registerPlugin(ScrollTrigger)

const $html = $('html')
const $body = $('body')
const $header = $('.js-header')
const $mobileHeader = $('.js-header-mobile-navigation')
const $menuModal = $('#menu-modal')

const menuToggle = new MenuToggle('.menu-toggle')


// Auto hiding header
ScrollTrigger.create({
  onUpdate: self => {

    if (self.scroll.v > 80){
      if (self.direction === 1){
        $header.addClass('hidden')
        //$mobileHeader.addClass('hidden')
      } else {
        $header.removeClass('hidden')
        //$mobileHeader.removeClass('hidden')
      }
    }

  },
});





// Open close menu on toggleMenu event from MenuToggle class
document.addEventListener("toggleMenu", function(e) {
  if(e.detail && e.detail.showMenu) {
    menuOpenAnimations()
  } else {
    menuCloseAnimations()
  }
})
$body.on('click', '.menu-modal-backdrop, .js-close-menu-modal', function () {
  menuToggle.closeButton()
})
$(document).keyup(function(e) {
  if (e.key === "Escape") { // escape key maps to keycode `27`
    menuToggle.closeButton()
  }
})



function menuOpenAnimations() {

  smoothScrollKill()

  $html.addClass('modal-visible')
  $header.addClass('menu-visible')
  $menuModal.addClass('modal-visible')

  gsap.fromTo('#menu-modal .menu-modal-backdrop', { opacity: 0}, { opacity: 0.2, duration: 0.4})
  gsap.fromTo('#menu-modal .menu-container', { opacity: 0, top: -100}, { opacity: 1, top: 0, duration: 0.65, ease: Power1.easeOut})

  gsap.fromTo('#menu-modal .menu .menu-item',
    {
      autoAlpha: 0,
      y: 10
    },
    {
      delay: 0.3,
      duration: 0.3,
      autoAlpha: 1,
      y: 0,
      stagger: 0.2,
      ease: Power2.easeInOut,
    }
  )


}


function menuCloseAnimations() {
  gsap.to('#menu-modal .menu-modal-backdrop', { opacity: 0, duration: 0.1, delay: 0.15})
  gsap.to('#menu-modal .menu-container', { top: -100, duration: 0.30, ease: Power1.easeIn})
  gsap.to('#menu-modal .menu-container', { opacity: 0, duration: 0.1, ease: Power1.easeIn, delay: 0.2, onComplete: hideMenuModal})

}
function hideMenuModal() {
  smoothScrollCreate()

  $html.removeClass('modal-visible')
  $header.removeClass('menu-visible')
  $menuModal.removeClass('modal-visible')

}


